import { IApplicationState } from '../../types/redux';
import { getUrlPath } from '../path';

export const mortgageSeoPageUrlSelector = (state: IApplicationState): string => {
  const fullPath = getUrlPath(state);

  return `${fullPath}ipoteka-zhk/`;
};
